import React from 'react';
/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="arrow_right" size=32 />
 */

var ArrowButton = function ArrowButton() {
  return React.createElement("path", {
    className: 'svg-arrow-path',
    d: "M17.3536 4.35355C17.5488 4.15829 17.5488 3.84171 17.3536 3.64645L14.1716 0.464466C13.9763 0.269204 13.6597 0.269204 13.4645 0.464466C13.2692 0.659728 13.2692 0.976311 13.4645 1.17157L16.2929 4L13.4645 6.82843C13.2692 7.02369 13.2692 7.34027 13.4645 7.53553C13.6597 7.7308 13.9763 7.7308 14.1716 7.53553L17.3536 4.35355ZM0 4.5H17V3.5H0V4.5Z"
  });
};

export default ArrowButton;